import { createSignal, Accessor, Setter } from 'solid-js';
import { GridRowData } from 'st-app/api';
import { uuidv4 } from 'common';


export class ExtendedRowData extends GridRowData {
    instanceId: string = uuidv4();
    isHighlighted: Accessor<boolean>;
    setIsHighlighted: Setter<boolean>;

    constructor() {
        super();

        [this.isHighlighted, this.setIsHighlighted] = createSignal<boolean>(false);
    }
}
